<script>
  import { t } from '$lib/translations'
</script>

<main class="bg-gray-100 min-h-screen">
  <header class="bg-cs-orange text-white py-8">
    <div class="container mx-auto px-4">
      <h1 class="text-4xl font-bold">{$t('projects.title1')}</h1>
      <p class="mt-2 text-xl">{$t('projects.title2')}</p>
    </div>
  </header>

  <section class="container mx-auto px-4 py-12">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
      <div class="bg-white rounded-lg shadow-md overflow-hidden">
        <img src="/projects/fast-pass.png" alt="Fast Pass" class="w-full h-80 object-cover" />
        <div class="p-6">
          <h2 class="text-2xl font-bold text-cs-orange mb-4">{$t('projects.fastPassTitle')}</h2>
          <p class="mb-4">{$t('projects.fastPassDescription')}</p>
          <ul class="list-disc list-inside">
            <li>{$t('projects.fastPassBenefit1')}</li>
            <li>{$t('projects.fastPassBenefit2')}</li>
            <li>{$t('projects.fastPassBenefit3')}</li>
          </ul>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow-md overflow-hidden">
        <img src="/projects/shuttle-planner.png" alt="Shuttle Planner" class="w-full h-80 object-cover" />
        <div class="p-6">
          <h2 class="text-2xl font-bold text-cs-orange mb-4">{$t('projects.shuttlePlannerTitle')}</h2>
          <p class="mb-4">{$t('projects.shuttlePlannerDescription')}</p>
          <ul class="list-disc list-inside">
            <li>{$t('projects.shuttlePlannerBenefit1')}</li>
            <li>{$t('projects.shuttlePlannerBenefit2')}</li>
            <li>{$t('projects.shuttlePlannerBenefit3')}</li>
          </ul>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow-md overflow-hidden flex-col items-center">
        <img src="/projects/ar.png" alt="Augmented Reality" class="w-full h-80 object-cover" />
        <div class="p-6">
          <h2 class="text-2xl font-bold text-cs-orange mb-4">{$t('projects.augmentedRealityTitle')}</h2>
          <p class="mb-4">{$t('projects.augmentedRealityDescription')}</p>
          <ul class="list-disc list-inside">
            <li>{$t('projects.augmentedRealityBenefit1')}</li>
            <li>{$t('projects.augmentedRealityBenefit2')}</li>
            <li>{$t('projects.augmentedRealityBenefit3')}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <footer class="bg-cs-orange text-white py-8 flex-col justify-center align-center">
    <img src="/projects/project-footer.png" alt="Project Footer" class='mx-auto'/>
    <div class="container mx-auto px-4 text-center">
      <p class="text-lg">{$t('projects.footer1')}</p>
      <p class="mt-2">{$t('projects.footer2')}</p>
    </div>
  </footer>
</main>
